import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { Tag } from '@nio-pow/cedar-design-web';
import { useEnvHint } from './HeaderUtils';
export default {
    __name: 'EnvTag',
    props: {
        visible: {
            type: Boolean,
            default: true
        }
    },
    setup (__props) {
        const { showEnvHint, envHintText, envHintTagColor } = useEnvHint();
        return (_ctx, _cache)=>{
            return _unref(showEnvHint) ? (_openBlock(), _createBlock(_unref(Tag), {
                key: 0,
                class: "env-tag-wrapper",
                color: _unref(envHintTagColor)
            }, {
                default: _withCtx(()=>[
                        _createTextVNode(_toDisplayString(_unref(envHintText)), 1)
                    ]),
                _: 1
            }, 8, [
                "color"
            ])) : _createCommentVNode("", true);
        };
    }
};
